import { Link, useLocation } from 'react-router-dom'

const TABS = [
  { to: '/audit', label: 'Log' },
  { to: '/audit/insights', label: 'Insights' },
]

/** Log ⇄ Insights switch for the page header. Carries the query string across. */
export function AuditTabs() {
  const { pathname, search } = useLocation()
  return (
    <nav aria-label="Audit views" className="flex shrink-0">
      {TABS.map((t, i) => {
        const active = pathname === t.to
        return (
          <Link
            key={t.to}
            to={{ pathname: t.to, search: active ? search : '' }}
            aria-current={active ? 'page' : undefined}
            className={[
              'border px-3 py-[5px] text-[12.5px] leading-4 transition-colors',
              i === 0 ? 'rounded-l-md' : '-ml-px rounded-r-md',
              active ? 'relative z-[1] border-line-strong bg-surface-active text-foreground' : 'border-input text-text-2 hover:text-foreground',
            ].join(' ')}
          >
            {t.label}
          </Link>
        )
      })}
    </nav>
  )
}
